export default [
    {
        name: 'hall',
        title: '攀岩馆',
        component: () => import(/* webpackChunkName: "hall" */ '../views/RockClimbing/Hall/index')
    },
    {
        name: 'hallLine',
        title: '攀岩馆',
        component: () =>
            import(/* webpackChunkName: "hallLine" */ '../views/RockClimbing/Hall/Line/index')
    },
    {
        name: 'hallLineDetail',
        title: '攀岩馆线路详情',
        component: () =>
            import(
                /* webpackChunkName: "hallLineDetail" */ '../views/RockClimbing/Hall/Line/detail'
            )
    },
    {
        name: 'hallClockInRanking',
        title: '岩馆打卡记录',
        component: () =>
            import(
                /* webpackChunkName: "hallClockInRanking" */ '../views/RockClimbing/Hall/clockInRanking'
            )
    },
    {
        name: 'hallPointsRanking',
        title: '岩馆打卡排行榜',
        component: () =>
            import(
                /* webpackChunkName: "hallPointsRanking" */ '../views/RockClimbing/Hall/pointsRanking'
            )
    }
]
